import axios from "axios"

export function getProductStockListing (parameters) {
  return new Promise((resolve, reject) => {
    axios.post(`/distributor/admin/api/v1/inventory/product/${parameters.id}/stock-list`, {
      length: parameters.length,
      start: parameters.start,
      order: parameters.order,
      order_by: parameters.order_by,
      dealer: parameters.dealer,
      filter: {
        search: parameters.filter.search,
        search_by: parameters.filter.search_by,
        nodes: parameters.filter.nodes,
        status: parameters.filter.status,
        box: parameters.filter.box,
        packed: parameters.filter.packed,
      }
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  })
}